import { Field } from 'components/Wizards/Field/Field'
import { Input } from 'almanac-ui/TextInputField/Input'
import { useEffect, useState } from 'react'
import { Text } from 'blaze-ui/Text/Text'

type Props = {
  details?: string
  onUpdate: (details: string) => void
}

const RepresentationDetails = ({ details, onUpdate }: Props) => {
  const [stagedValue, setStagedValue] = useState(details || '')

  useEffect(() => {
    if (details) {
      setStagedValue(details)
    }
  }, [details])

  return (
    <Field label="Additional Details" labelType="label" data-testid="representation-details">
      <Input
        name="representation-details"
        isTextarea
        aria-label="Additional details"
        value={stagedValue}
        onChange={(e) => setStagedValue(e.target.value)}
        placeholder="Describe cultural cues, style, or context to guide representation"
        rows={3}
        size="lg"
        onBlur={() => onUpdate(stagedValue)}
      />
      <Text variant="placeholder">
        We will make a best effort to apply this to your content. However, please note that it may not always work.
      </Text>
    </Field>
  )
}

export { RepresentationDetails }
